<template>
  <footer class="relative overflow-hidden bg-gray-900 text-white">
    <div class="absolute inset-0 bg-gradient-to-br from-gray-900 via-[#1a1f35] to-[#17263c]"></div>
    
    <!-- 技术关键词装饰 -->
    <div class="absolute inset-0 overflow-hidden select-none pointer-events-none">
      <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] opacity-10">
        <!-- 外圈关键词 -->
        <div class="absolute inset-0 animate-spin-slow">
          <span class="absolute top-0 left-1/2 -translate-x-1/2 text-sm whitespace-nowrap">{{ t('landing.footer.keywords.neural') }}</span>
          <span class="absolute top-1/4 right-0 text-sm whitespace-nowrap">{{ t('landing.footer.keywords.machine') }}</span>
          <span class="absolute bottom-1/4 right-0 text-sm whitespace-nowrap">{{ t('landing.footer.keywords.deep') }}</span>
          <span class="absolute bottom-0 left-1/2 -translate-x-1/2 text-sm whitespace-nowrap">{{ t('landing.footer.keywords.vision') }}</span>
          <span class="absolute bottom-1/4 left-0 text-sm whitespace-nowrap">{{ t('landing.footer.keywords.nlp') }}</span>
          <span class="absolute top-1/4 left-0 text-sm whitespace-nowrap">{{ t('landing.footer.keywords.mining') }}</span>
        </div>
        <!-- 中圈关键词 -->
        <div class="absolute inset-[100px] animate-spin-slow-reverse">
          <span class="absolute top-0 left-1/2 -translate-x-1/2 text-sm whitespace-nowrap">{{ t('landing.footer.keywords.tiktok') }}</span>
          <span class="absolute top-1/4 right-0 text-sm whitespace-nowrap">{{ t('landing.footer.keywords.facebook') }}</span>
          <span class="absolute bottom-1/4 right-0 text-sm whitespace-nowrap">{{ t('landing.footer.keywords.analysis') }}</span>
          <span class="absolute bottom-0 left-1/2 -translate-x-1/2 text-sm whitespace-nowrap">{{ t('landing.footer.keywords.market') }}</span>
          <span class="absolute bottom-1/4 left-0 text-sm whitespace-nowrap">{{ t('landing.footer.keywords.content') }}</span>
          <span class="absolute top-1/4 left-0 text-sm whitespace-nowrap">{{ t('landing.footer.keywords.creative') }}</span>
        </div>
        <!-- 内圈关键词 -->
        <div class="absolute inset-[200px] animate-spin-slow">
          <span class="absolute top-0 left-1/2 -translate-x-1/2 text-sm whitespace-nowrap">{{ t('landing.footer.keywords.roi') }}</span>
          <span class="absolute top-1/4 right-0 text-sm whitespace-nowrap">{{ t('landing.footer.keywords.insights') }}</span>
          <span class="absolute bottom-1/4 right-0 text-sm whitespace-nowrap">{{ t('landing.footer.keywords.trend') }}</span>
          <span class="absolute bottom-0 left-1/2 -translate-x-1/2 text-sm whitespace-nowrap">{{ t('landing.footer.keywords.metrics') }}</span>
          <span class="absolute bottom-1/4 left-0 text-sm whitespace-nowrap">{{ t('landing.footer.keywords.campaign') }}</span>
          <span class="absolute top-1/4 left-0 text-sm whitespace-nowrap">{{ t('landing.footer.keywords.analysis') }}</span>
        </div>
      </div>
    </div>

    <div class="container mx-auto px-4 py-20 relative">
      <div class="text-center">
        <h2 class="text-3xl md:text-4xl font-semibold mb-6">
          {{ t('landing.footer.title') }}
        </h2>
        <p class="text-gray-400 mb-8 max-w-2xl mx-auto">
          {{ t('landing.footer.description') }}
        </p>
        <div class="flex flex-col md:flex-row items-center justify-center gap-4">
          <button class="w-full md:w-auto bg-primary-500 text-white px-8 py-3 rounded-full hover:bg-primary-600 transition-colors">
            {{ t('landing.cta.getStarted') }}
          </button>
          <button class="w-full md:w-auto bg-white/10 text-white px-8 py-3 rounded-full hover:bg-white/20 transition-colors">
            {{ t('landing.cta.learnMore') }}
          </button>
        </div>
      </div>

      <div class="grid grid-cols-2 md:grid-cols-4 gap-8 mt-16">
        <div>
          <h3 class="text-lg font-semibold mb-4">{{ t('landing.footer.sections.product.title') }}</h3>
          <ul class="space-y-2">
            <li><a href="#features" class="text-gray-400 hover:text-white transition-colors">{{ t('landing.footer.sections.product.features') }}</a></li>
            <li><a href="#pricing" class="text-gray-400 hover:text-white transition-colors">{{ t('landing.footer.sections.product.pricing') }}</a></li>
            <li><a href="#cases" class="text-gray-400 hover:text-white transition-colors">{{ t('landing.footer.sections.product.cases') }}</a></li>
            <li><a href="#api" class="text-gray-400 hover:text-white transition-colors">{{ t('landing.footer.sections.product.api') }}</a></li>
          </ul>
        </div>
        <div>
          <h3 class="text-lg font-semibold mb-4">{{ t('landing.footer.sections.resources.title') }}</h3>
          <ul class="space-y-2">
            <li><a href="/docs" class="text-gray-400 hover:text-white transition-colors">{{ t('landing.footer.sections.resources.docs') }}</a></li>
            <li><a href="/tutorials" class="text-gray-400 hover:text-white transition-colors">{{ t('landing.footer.sections.resources.tutorials') }}</a></li>
            <li><a href="/blog" class="text-gray-400 hover:text-white transition-colors">{{ t('landing.footer.sections.resources.blog') }}</a></li>
            <li><a href="/support" class="text-gray-400 hover:text-white transition-colors">{{ t('landing.footer.sections.resources.support') }}</a></li>
          </ul>
        </div>
        <div>
          <h3 class="text-lg font-semibold mb-4">{{ t('landing.footer.sections.company.title') }}</h3>
          <ul class="space-y-2">
            <li><a href="/about" class="text-gray-400 hover:text-white transition-colors">{{ t('landing.footer.sections.company.about') }}</a></li>
            <li><a href="/contact" class="text-gray-400 hover:text-white transition-colors">{{ t('landing.footer.sections.company.contact') }}</a></li>
            <li><a href="/careers" class="text-gray-400 hover:text-white transition-colors">{{ t('landing.footer.sections.company.careers') }}</a></li>
            <li><a href="/partners" class="text-gray-400 hover:text-white transition-colors">{{ t('landing.footer.sections.company.partners') }}</a></li>
          </ul>
        </div>
        <div>
          <h3 class="text-lg font-semibold mb-4">{{ t('landing.footer.sections.legal.title') }}</h3>
          <ul class="space-y-2">
            <li><a href="/privacy" class="text-gray-400 hover:text-white transition-colors">{{ t('landing.footer.sections.legal.privacy') }}</a></li>
            <li><a href="/terms" class="text-gray-400 hover:text-white transition-colors">{{ t('landing.footer.sections.legal.terms') }}</a></li>
            <li><a href="/cookies" class="text-gray-400 hover:text-white transition-colors">{{ t('landing.footer.sections.legal.cookies') }}</a></li>
            <li><a href="/security" class="text-gray-400 hover:text-white transition-colors">{{ t('landing.footer.sections.legal.security') }}</a></li>
          </ul>
        </div>
      </div>

      <div class="mt-16 pt-8 border-t border-gray-800">
        <div class="flex flex-col md:flex-row items-center justify-center gap-4">
          <p class="text-gray-400">{{ t('landing.footer.copyright') }} &copy; 2025 Lagent.</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
const { t } = useI18n()
</script>

<style scoped>
@keyframes spin-slow {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes spin-slow-reverse {
  from {
    transform: rotate(360deg);
  }
  to {
    transform: rotate(0deg);
  }
}

.animate-spin-slow {
  animation: spin-slow 30s linear infinite;
}

.animate-spin-slow-reverse {
  animation: spin-slow-reverse 25s linear infinite;
}
</style>
